<template>
    <div class="row">
        <div class="col">
            <div class="top-filters">
                <div id="rcdc-top-filter">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text sr-only" id="rcdc-top-filter-label">Filter RCDC Categories</span>
                        </div>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Filter RCDC Categories"
                            aria-label="Filter RCDC Categories" aria-describedby="rcdc-top-filter-label"
                            :disabled="currentView !== 'home'"
                            :class="{'disabled': currentView !== 'home'}"
                            @input="filterRcdc()"
                            v-model="rcdcFilterValue"
                        >
                        <v-button
                            :customLabel="''"
                            :svg="'fa fa-times-circle'"
                            class="rcdc-top-filter-clear-btn"
                            v-if="rcdcFilterValue && currentView === 'home'"
                            @click="filterRcdc(true)"
                            :srOnlyLabel="'X'"
                        />
                    </div>
                </div>
                <div id="dropdowns-top-filter">
                    <!-- ICs -->
                    <v-dropdown
                        :customId="'ic-top-filter'"
                        :customLabel="selectedIcDropdownLabel"
                        :customListItemLabel="selectedIcFilter"
                        :selectedValueField="'ic'"
                        :dropdownData="topFilterPresets.ics"
                        :activeDropdownValue="selectedIcFilter"
                        :svg="'fas fa-chevron-down'"
                        :svgAlt="'Select value'"
                        v-if="currentView == 'home'"
                    />

                    <!-- FISCAL YEAR -->
                    <v-dropdown
                        :customId="'fiscal-year-top-filter'"
                        :customLabel="'' + selectedYearDropdownLabel"
                        :customListItemLabel="selectedYear"
                        :selectedValueField="'fiscalYear'"
                        :dropdownData="topFilterPresets.fiscalYears"
                        :activeDropdownValue="selectedYear"
                        :svg="'fas fa-chevron-down'"
                        :svgAlt="'Select value'"
                        :disabled="currentView == 'ic'"
                    />

                    <!-- FACET -->
                    <v-dropdown
                        :customId="'facet-top-filter'"
                        :customLabel="selectedFacetDropdownLabel"
                        :dropdownData="topFilterPresets.facets"
                        :selectedValueField="'facet'"
                        :activeDropdownValue="selectedFacet"
                        :svg="'fas fa-chevron-down'"
                        :svgAlt="'Select value'"
                        :disabled="currentView == 'ic'"
                    />

                    <!-- SINGLE GENDER -->
                    <v-checkbox
                        :customId="'single-gender-top-filter'"
                        :customLabel="'Exclude single ' + customFacetText + ' studies'"
                        :disabled="currentView === 'ic'"
                        :customClass="'top-filter-checkbox'"
                        :selectedValueField="'single'"
                        :selectedValue="singleStudiesFilter"
                        :trueValue="'Exclude Singles'"
                        :falseValue="'All Studies'"
                        ref="singleCheckbox"
                    />
                     <!-- CLEAR FILTERS -->
                    <v-button
                        :customLabel="'Clear Filters'"
                        class="top-filter-clear-btn"
                        v-if="currentView === 'home'"
                        @click="resetFilters()"
                    />
                </div>

                <!-- EXPORT -->
                <v-dropdown
                    :customId="'export-top-filter'"
                    :customClass="'export-dropdown'"
                    :customLabel="'Export'"
                    :dropdownData="exportOptions"
                    :svg="'fas fa-download'"
                    :selectedValueField="'export'"
                    :svgAlt="'Select value'"
                    :menuRight="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import globalMixins from '@/js/globalMixins';
import tableExport from 'tableexport';
import bus from '@/js/event-bus.js';

export default {
    name: 'TopFilters',
    mixins: [globalMixins],
    computed: {
        ...mapGetters([
            'topFilterPresets',
            'selectedYear',
            'yearsData',
            'exportOptions',
            'selectedFacet',
            'singleStudiesFilter',
            'selectedRcdc',
            'selectedIc',
            'selectedIcFilter',
            'rcdcFilterValue',
        ]),
        rcdcFilterValue: {
            get () {
                return this.$store.getters.rcdcFilterValue;
            },
            set (value) {
                this.$store.commit('setRcdcFilterValue', value);
            }
        },
        selectedYearDropdownLabel: function () {
            return this.selectedYear;
        },
        selectedFacetDropdownLabel: function () {
            return this.selectedFacet;
        },
        selectedIcDropdownLabel: function () {
            return this.selectedIcFilter;
        },
        customFacetText: function () {
            if (this.selectedFacet === 'Gender') {
                return 'Sex/Gender';
            } else {
                return this.selectedFacet;
            }
        }
    },
    data: function () {
        return {
            exportInstance: []
        };
    },
    mounted () {
        bus.$on('filter:click', (data, value) => {
            if (data.selectedValueField != 'export') {
                this.setTopLineFilterValue(data, value)
            } else {
                this.exportTable(data)
            }
        });
    },
    methods: {
        ...mapActions([
            'setYearsData',
            'setSelectedIcFilter',
            'setSelectedYear',
            'setSelectedFacet',
            'setSingleStudiesFilter',
            'setLoadingNewData',
            'setTableColumns',
            'parseAndFilterRawData',
            'setIcViewFromHome',
            'resetTopFilters'
        ]),
        filterRcdc (clearFilter) {
            var routerQuery = copyData(this.$route.query),
                path = this.$route.path === '/' ? 'home' : this.$route.path;

            if (clearFilter) {
                this.rcdcFilterValue = null;
                delete routerQuery.rcdcFilter;
            } else {
                routerQuery.rcdcFilter = this.rcdcFilterValue;
            }

            this.$router.replace({
                path: path,
                query: routerQuery
            });

            this.parseAndFilterRawData().then(() => {
                bus.$emit('setTableData');
            });
        },
        setTopLineFilterValue (filterValue, fromRouting) {
            var value = filterValue.value,
                path = this.$route.path === '/' ? 'home' : this.$route.path,
                routerQuery = copyData(this.$route.query),
                setQueryValue;

            setQueryValue = (reloadData) => {
                if (this.currentView === 'home' || this.currentView === 'ic') {
                    routerQuery[filterValue.selectedValueField] = value;

                    if (!this.selectedIcFilter) {
                        delete routerQuery.ic;
                    }

                    this.$router.replace({
                        path: path,
                        query: routerQuery
                    });
                }

                if (reloadData) {
                    this.parseAndFilterRawData().then(() => {
                        bus.$emit('setTableData');
                    });
                }
            };

            this.setLoadingNewData(true);
            switch (filterValue.selectedValueField) {
                case 'fiscalYear':
					
					gtag('event','Click', {
						'event_category': 'Top filters fiscal year: ' + value,
						'event_label': 'Select top filter value',
						'value': value
					  });
					                   
                    setTimeout(() => {
                        this.setSelectedYear(value).then(() => {
                            if (!this.yearsData[value]) {
                                let yearStr = value + '/',
                                    allFyData = [],
                                    loadCnt = 1;
                                this.getSelectedYearData(yearStr + value).done((data) => {
                                    let fyRecord = _.filter(this.topFilterPresets.fiscalYears, (fyRec) => {
                                        return fyRec.value === value;
                                    });
                                    allFyData = allFyData.concat(data);
                                    if (fyRecord.length > 0 && fyRecord[0].fileCount && fyRecord[0].fileCount > 1) {
                                        for (let i = 1; i < fyRecord[0].fileCount; i++) {
                                            this.getSelectedYearData(yearStr + value + '_' + (i)).done((partData) => {
                                                loadCnt++;
                                                allFyData = allFyData.concat(partData);
                                                if (loadCnt === fyRecord[0].fileCount) {
                                                    this.setYearsData({'year': value, 'data': allFyData}).then(() => {
                                                        setQueryValue(true);
                                                    });
                                                    this.init = true;
                                                }
                                            });
                                        }
                                    } else {
                                        this.setYearsData({'year': value, 'data': data}).then(() => {
                                            setQueryValue(true);
                                        });
                                    }
                                });
                            } else {
                                setQueryValue(true);
                            }
                            this.setLoadingNewData(false);
                        });
                    }, 301);


                    break;
                case 'facet':
					gtag('event','Click', {
						'event_category':  'Top filters facet: ' + value,
						'event_label': 'Select top filter value',
						'value': value
					  });

                    setTimeout(() => {
                        this.setSelectedFacet(value);
                        this.setTableColumns({data: window[value + 'Columns'], route: this.$route}).then(() => {
                            setQueryValue();
                            this.setLoadingNewData(false);
                            setTimeout(() => {
                                window.calculateScrollTableHeight($('.home__main-table').find('.scroll-table'));
                            }, 301);
                        });
                    }, 301);

                    break;

                case 'single':
					gtag('event','Click', {
						'event_category': 'Top filters single studies: ' + (filterValue.value ? 'Exclude' : 'All') + ' ' + filterValue.selectedValueField,
						'event_label': 'Select top filter value',
						'value': (filterValue.value ? 'Exclude' : 'All') + ' ' + filterValue.selectedValueField
					  });
					                     

                    if (fromRouting) {
                        this.$refs.singleCheckbox.checked = value === 'Exclude';
                    }


                    setTimeout(() => {
                        this.setSingleStudiesFilter(value).then(() => {
                            setQueryValue(true);
                            this.setLoadingNewData(false);
                        });
                    }, 301);
                    break;

                case 'ic':
					gtag('event','Click', {
						'event_category':  'Top filters IC: ' + value,
						'event_label': 'Select top filter value',
						'value': value
					  });					                     

                    if (!value) {
                        this.setIcViewFromHome(false);
                    } else {
                        this.setIcViewFromHome(true);
                    }

                    setTimeout(() => {
                        this.setSelectedIcFilter(value).then(() => {
                            setQueryValue(true);
                            this.setLoadingNewData(false);
                        });
                    }, 301);
                    break;
            }
        },
        resetFilters () {
            this.setLoadingNewData(true);
            this.$router.replace({
                path: '/',
                query: null
            });

            this.resetTopFilters().then(() => {
                this.setTableColumns({data: window[this.selectedFacet + 'Columns'], route: this.$route}).then(() => {
                    setTimeout(() => {
                        window.calculateScrollTableHeight($('.home__main-table').find('.scroll-table'));
                    }, 301);
                });

                
                this.parseAndFilterRawData().then(() => {
                    bus.$emit('setTableData');
                });
            });
        },
        exportTable (exportType) {
            var exportData,
                baseFileName = '',
                self = this;

            tableExport.prototype.typeConfig.date.assert = function () {
                return false;
            };

            tableExport.prototype.formatConfig.xlsx = {
                mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                fileExtension: '.xlsx'
            };

            tableExport.prototype.formatConfig.csv = {
                mimeType: 'application/csv',
                fileExtension: '.csv'
            };

            this.selectedRcdc ? baseFileName += this.selectedRcdc.replace(/[^\w\s]/gi, '').substring(0, 8) + '-' : '';

            this.selectedIc ? baseFileName += this.selectedIc.replace(/[^\w\s]/gi, '') + '-' : '';
			
			gtag('event','Click', {
						'event_category':  'Export ' + this.currentView + ' to ' + exportType.value,
						'event_label': 'Export',
						'value': 'Export'
					  });	

            var i = 0,
                fileName = [];
            $('.table-comp__floating-table').each(function () {
                if (self.currentView === 'ic') {
                    fileName[i] = baseFileName + self.selectedYear + '-' + $(this).attr('name') + '-' + (self.singleStudiesFilter === 'All' ? 'Inc-Single' : 'Exc-Single');
                } else {
                    fileName[i] = baseFileName + self.selectedYear + '-' + self.selectedFacet + '-' + (self.singleStudiesFilter === 'All' ? 'Inc-Single' : 'Exc-Single');
                }

                fileName[i] = fileName[i].substring(0, 31);

                self.exportInstance[i] = tableExport($(this), {
                    formats: ['xls', 'csv'],
                    exportButtons: false,
                    filename: fileName[i]
                });

                exportData = self.exportInstance[i].getExportData()[$(this).attr('id')][exportType.value];

                self.exportInstance[i].export2file(exportData.data, exportData.mimeType, exportData.filename, exportData.fileExtension);
                i++;
            });

            self.exportInstance = [];
        }
    }
};
</script>

<style lang="scss">
.top-filters {
    padding: 5px $home-page-padding;
    background-color: #ececec;
    @include clearfix();

    .dropdown,
    .top-filter-checkbox {
        float: left;
    }

    .dropdown.export-dropdown,
     {
        float: right;
    }

    @media only screen and (max-width: 945px) {
        #rcdc-top-filter {
            display: block;
            width: 100%;
            margin-bottom: 5px;
        }
    }

    @media only screen and (max-width: 740px) {
        #dropdowns-top-filter {
            display: block;
            width: 100%;
            margin-bottom: 5px;
        }

        .dropdown.export-dropdown {
            float: left;
        }
    }

    @media only screen and (max-width: 650px) {
        #dropdowns-top-filter {
            .dropdown {
                display: block;
                width: 100%;
                margin-bottom: 5px;
            }
        }
    }

    // @media only screen and (max-width: 595px) {
    //     .top-filter-checkbox {
    //         margin-right: 10px;
    //     }
    //     .dropdown.export-dropdown {
    //         margin: 10px 0;
    //         float: left;
    //     }
    // }

    // @media only screen and (max-width: 520px) {
    //     .top-filter-checkbox {
    //         margin: 10px 10px 10px 0;
    //     }
    // }

    #dropdowns-top-filter {
        display: inline-block;
    }

    #rcdc-top-filter {
        float: left;
        margin-right: 10px;
        // border-bottom: 1px solid #555555;
        position: relative;
        .input-group {
            position: relative;
            width: 200px;
        }

        input {
            width: 200px;
            height: 27px;
            border: none;
            border-radius: 4px;
            border-bottom: 2px solid #bfb9b9;

            &::placeholder {
                font-style: italic;
                font-weight: bold;
                font-size: 12px;
                padding-left: 5px;
            }
        }
    }

    #rcdc-top-filter-label {
        @include sr-only();
    }

    .rcdc-top-filter-clear-btn.custom-btn.svg-only {
        padding: 0px 3px;
        border-radius: 10px;
        position: absolute;
        right: 5px;
        top: 3px;
        .svg {
            color: #833233;
            width: 14px;
            height: 14px;
        }
    }

    .top-filter-clear-btn {
        background-color: #6c757d;
        color: #fff;

        &:active,
        &:focus {
            background-color: #6c757d!important;
        }

        &:hover {
            background-color: lighten(#6c757d, 10%)!important;
        }
    }
}

.ie {
    #rcdc-top-filter {
        input {
            height: 26px;
        }
    }
}

.top-filter-checkbox {
    margin-right: 10px;
}


</style>

